import { render, staticRenderFns } from "./AdminPaymentsHistory.vue?vue&type=template&id=6aa667f8"
import script from "./AdminPaymentsHistory.vue?vue&type=script&lang=js"
export * from "./AdminPaymentsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports